import { render, staticRenderFns } from "./course-type-card.vue?vue&type=template&id=59cd6fb4&scoped=true"
import script from "./course-type-card.vue?vue&type=script&lang=js"
export * from "./course-type-card.vue?vue&type=script&lang=js"
import style0 from "./course-type-card.vue?vue&type=style&index=0&id=59cd6fb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cd6fb4",
  null
  
)

export default component.exports